export default __webpack_public_path__ + "static/media/Mark-3-Suit-02.02be5059.jpg";